// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const MemberIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 26 30" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M19.025 17.4875L17.725 16.8L18.85 15.8375C20.85 14.125 22 11.625 22 9C22 4.0375 17.9625 0 13 0C8.0375 0 4 4.0375 4 9C4 11.625 5.15 14.125 7.1625 15.8375L8.2875 16.8L6.9875 17.4875C2.675 19.75 0 24.1625 0 29C0 29.55 0.45 30 1 30H25C25.55 30 26 29.55 26 29C26 24.1625 23.325 19.75 19.025 17.4875ZM6 9C6 5.1375 9.1375 2 13 2C16.8625 2 20 5.1375 20 9C20 12.8625 16.8625 16 13 16C9.1375 16 6 12.8625 6 9ZM1.975 28L2.225 26.8C3.2625 21.7 7.7875 18 13 18C18.2125 18 22.7375 21.7 23.775 26.8L24.025 28H1.975Z" />
        </svg>
      )
    }
  </Icon>
);

export default MemberIcon;
